import * as Sentry from "@sentry/react";
import { env } from "config/env";
import React from "react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router";

Sentry.init({
  enabled: !env.IS_LOCAL,
  dsn: env.REACT_APP_SENTRY_DSN,
  environment: env.REACT_APP_ENV,

  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,

  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.launchDarklyIntegration(),
    Sentry.httpClientIntegration({ failedRequestTargets: [env.REACT_APP_SG_API_URL, window.location.origin] }),
    Sentry.thirdPartyErrorFilterIntegration({
      filterKeys: ["qwick-marketplace"],
      // apply tag to observe how many errors are from third-party code
      // change to drop if the tagging works as expected
      behaviour: "apply-tag-if-contains-third-party-frames",
    }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 0.1,
  // relative to the transaction sample rate
  profilesSampleRate: 0.5,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  // tracePropagationTargets: [env.REACT_APP_SG_API_URL],
});

export { Sentry };
